import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container
} from "reactstrap";
import { getAllPartiesCustomerData } from "../../store/Parties/Customer/action";
import { getCustomersCityData, updateCustomerSwitchData } from "../../store/Parties/actions";
import ModalCustomerValue from "./Modal/ModalCustomerValue";
import {
  City,
  CommonValue,
  ConatctNo,
  ContactName,
  Country,
  CustomerName,
  CustomerType,
  EmailId
} from "./PartiesCol";
import TableCustomers from "./TableCustomers";
import TopBreadcrumbs from "../Settings/Surcharge/TopBreadcrumbs";
import { customersBreadcrumb } from "../../common/data/parties";
import { Edit } from "../Settings/SettingsCol";
import { useNavigate } from "react-router-dom";
import FilterCustomerComp from "./Modal/FilterCustomerComp";
import { getInternalRoute } from "../../components/Common/CommonLogic";

const Customers = () => {
  const [modal, setModal] = useState(false);
  const [viewData, setViewData] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(0);
  const { customer_data, customer_loader } = useSelector((state) => state?.customer);
  const [isRight, setIsRight] = useState(false);
  const inputArr = {
    contactName: '',
    country: '',
    city: '',
    customer: '',
    sales_employee: '',
  }
  const [filterDetails, setfilterDetails] = useState(inputArr);

  const viewPopupHandler = (data) => {
    setModal(true);
    setViewData(data);
  };

  const onCloseClick = () => {
    setModal(false);
  }

  const switchHandler = (data) => {
    dispatch(updateCustomerSwitchData(data.id, data.is_active));
  }
  const editHandler = (data) => {
    console.log(data);
    navigate(getInternalRoute("customer-add"), {
      state: {
        id: data?.id || '',
        data: data
      },
    });
  };

  useEffect(() => {
    dispatch(getCustomersCityData())
  }, [dispatch]);

  const toggleRightCanvas = () => {
    setIsRight(!isRight);
  };

  const constructUrl = (page, filters) => {
    let url = `?page=${page}&size=10&`;
    url += `${filters?.customer ? `customerName=${filters?.customer}&` : ''}`;
    //url += `${filters?.country?.id ? `countryId=${filters?.country.id}&` : ''}`;
    url += `${filters?.city?.id ? `cityId=${filters?.city.id}&` : ''}`;
    url += `${filters?.sales_employee?.id ? `salesEmployees=${filters?.sales_employee.id}&` : ''}`;
    url += `${filters?.contactName ? `contactName=${filters?.contactName}&` : ''}`;
    return url.substring(0, url.length - 1); 
  };
  const applyFilterHandler = () => {
    setIsRight(false);
    let url = constructUrl(currentPage, filterDetails);
    dispatch(getAllPartiesCustomerData(url));
  };

  const clearValueHandler = () => {
    setfilterDetails(inputArr);
    let url = constructUrl(currentPage, {});
    dispatch(getAllPartiesCustomerData(url));
    setIsRight(false);
  };
  useEffect(() => {
    let url = constructUrl(currentPage, filterDetails);
    dispatch(getAllPartiesCustomerData(url));
  }, [currentPage]);

  const columns = useMemo(
    () => [
      {
        Header: "Customer Code",
        accessor: "customerCode",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <CommonValue
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Customer Name",
        accessor: "name",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <CustomerName
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Customer Type",
        accessor: "customerType",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <CustomerType
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Contact Name",
        accessor: "contactName",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <ContactName
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Contact No",
        accessor: "contactNo",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <ConatctNo
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Email Id",
        accessor: "contactEmail",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <EmailId
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "City",
        accessor: "city.cityName",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <City cellProps={cellProps} viewPopupHandler={viewPopupHandler} />
          );
        },
      },
      {
        Header: "Country",
        accessor: "country.countryName",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <Country
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Sales Manager",
        accessor: "salesUser.firstName",
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <CommonValue
              cellProps={cellProps}
              viewPopupHandler={viewPopupHandler}
            />
          );
        },
      },
      {
        Header: "Edit",
        Cell: (cellProps) => {
          return <Edit cellProps={cellProps} viewPopupHandler={editHandler} />
        },
      },
    ],
    []
  );

  return (
    <>
      <div className="page-content settings_users_wrapper">
        <Container fluid>
          <div className="main_freight_wrapper">
            {/* breadcrumbs */}
            <TopBreadcrumbs breadcrumbs={customersBreadcrumb} isBackRequired={false} />
            
            <TableCustomers
              columns={columns}
              data={customer_data?.content || []}
              isGlobalFilter={true}
              isAddInvoiceList={true}
              customPageSize={10}
              toggleRightCanvas={toggleRightCanvas}
              component={"Customers"}
              loader={customer_loader || false}
              setCurrentPage={setCurrentPage}
              totalPages={customer_data?.totalPages || 0}
              totalEntries={customer_data?.totalElements || 0}
            />

            {/* modal */}
            <ModalCustomerValue modal={modal} onCloseClick={onCloseClick} viewData={viewData} modalType={'customer'} />
          </div>
        </Container>
        <FilterCustomerComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />
      </div>
    </>
  );
};

export default Customers;
